<h1 class="text-center">{{message('skillsHeader')}}</h1>

<form>
  <div class="form-group">
    <div class="dropdown w-95 mx-auto">
      <label class="sr-only" for="skillSelectInput">{{message('skillsHeader')}}</label>
      <input #skillSearchBox (input)="onSkillsSearchInput(skillSearchBox.value)"
             class="dropdown-toggle form-control dark-input"
             [placeholder]="message('skillSearchPlaceholder')" data-toggle="dropdown" id="skillSelectInput"
             type="search" autocomplete="off">
      <div aria-labelledby="skillSelectInput" class="dropdown-menu dark-input">
        <a (click)="onSkillSelect(skill)" *ngFor="let skill of filteredSkills" class="dropdown-item dark-input"
           href="#">
          <img [alt]="skill.name" [ngStyle]="{'background': 'url(' + getSkillImageUrl(skill) + ') no-repeat ' + getSpritePosition(skill) + '/256px'}"
               class="skillSprite mr-2" [src]="imageTemplateUrl">
          {{skill.name}}
        </a>
      </div>
    </div>

    <div class="divider form-group" id="selectedSkills">
      <div *ngFor="let skill of selectedSkills" class="row skillRow mx-auto form-group">
        <div class="col-9">
          <img [alt]="skill.name" [ngStyle]="{'background': 'url(' + getSkillImageUrl(skill) + ') no-repeat ' + getSpritePosition(skill) + '/256px'}"
               class="skillSprite mr-2" [src]="imageTemplateUrl">
          <label class="bump-down" for="{{skill.nameID}}-levelInput">{{skill.name}}</label>
        </div>
        <div class="col-2">
          <input (keydown)="onLevelChange(skill, $event)" [value]="skill.level"
                 class="levelInput form-control dark-input" id="{{skill.nameID}}-levelInput"
                 [class.read-only]="skillLevelIsReadOnly(skill)" type="number" [readonly]="skillLevelIsReadOnly(skill)">
        </div>
        <div class="col-1">
          <span (click)="onRemoveSkill(skill)" class="material-icons md-light hoverable mt-1">close</span>
        </div>
        <div class="w-100"></div>
        <ng-template [ngIf]="skill.lavishWorkspace && skill.level > 5">
          <div class="col-6">
            <label class="bump-down small pl-5" for="{{skill.nameID}}-lavishWorkspace">
              {{message('lavishWorkspace')}}
            </label>
          </div>
          <div class="col">
            <input #lavish (change)="onUpdateLavish(skill, lavish.checked)"
                   [checked]="skill.lavishChecked" class="lavishInput form-control dark-input"
                   id="{{skill.nameID}}-lavishWorkspace"
                   type="checkbox">
          </div>
        </ng-template>
      </div>
    </div>

    <div class="dropdown w-95 mx-auto">
      <input #tableSearchBox (input)="onTablesSearchInput(tableSearchBox.value)"
             [placeholder]="message('tableSearchPlaceholder')"
             class="dropdown-toggle form-control dark-input" data-display="static" data-toggle="dropdown"
             id="tableSelectInput"
             type="search">
      <div aria-labelledby="tableSelectInput" class="dropdown-menu dark-input dropdown-menu-right">
        <a (click)="onTableSelect(table)" *ngFor="let table of filteredTables" class="dropdown-item dark-input"
           href="#">
          <img [alt]="table.name"
               [ngStyle]="{'background': 'url(' + imageBaseUrl + table.imageFile + ') no-repeat',
                'background-position': getTableSpritePosition(table),
                'background-size': '512px'}"
               class="tableSprite mr-2"
               [src]="imageTemplateUrl">{{table.name}}
        </a>
      </div>
    </div>

    <div class="pt-1" id="craftingTables">
      <div *ngFor="let table of craftingTables">
        <div *ngIf="table.availableUpgrades !== undefined && table.availableUpgrades.length > 0"
             class="row upgradeRow mx-auto form-group">
          <div class="col-8">
            <img [alt]="table.name"
                 [ngStyle]="{'background': 'url(' + imageBaseUrl + table.imageFile + ') no-repeat',
                'background-position': getTableSpritePosition(table),
                'background-size': '512px'}"
                 class="tableSprite mr-2"
                 [src]="imageTemplateUrl">
            <label class="bump-down" for="{{table.nameID}}-upgradeButton">{{table.name}}</label>
          </div>
          <div class="col-3 dropdown">
            <button aria-expanded="false" aria-haspopup="true"
                    class="btn dark-input dropdown-toggle float-right"
                    data-toggle="dropdown" id="{{table.nameID}}-upgradeButton" type="button">
              {{table.selectedUpgrade.name}}
            </button>
            <div aria-labelledby="{{table.nameID}}-upgradeButton" class="dropdown-menu dark-input">
              <a (click)="onUpgradeSelect(table, upgrade)" *ngFor="let upgrade of table.availableUpgrades"
                 class="dropdown-item dark-input" href="#">
                {{upgrade.name}}
              </a>
            </div>
          </div>
          <div class="col-1">
            <span (click)="onRemoveTable(table)" class="material-icons md-light hoverable mt-1">close</span>
          </div>
        </div>
      </div>
    </div>
  </div>


</form>

